import { IDynamicQueryService } from "../../service/dynamicQuery/DynamicQueryService";
import { IDynamicQuery } from "../../model/dynamicQuery/DynamicQuery";

export default class UpdateDynamicQueryInteractor {
  private dynamicQueryService: IDynamicQueryService;

  constructor(dynamicQueryService) {
    this.dynamicQueryService = dynamicQueryService;
  }

  async execute(code: string, dynamicQuery: IDynamicQuery) {
    return this.dynamicQueryService.updateDynamicQuery(code, dynamicQuery);
  }
}
